import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { ReactNode } from 'react'
import { SlideOverDialogHeader } from './SlideOverDialogHeader'

type PropTypes = {
  title: string
  open: boolean
  onClose: () => void
  children?: ReactNode
}

export const SlideOverDialog = ({open, onClose, title, children}: PropTypes) => (
  <Dialog open={open} className="fixed inset-0 z-10" onClose={onClose}>
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-gray-800/40 backdrop-blur transition-opacity duration-500 ease-in-out data-closed:opacity-0"
    />

    <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden ">
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
          <DialogPanel
            transition
            className="pointer-events-auto w-screen max-w-[calc(100vw-2.5rem)] sm:max-w-[calc(100vw-4rem)] md:max-w-2xl lg:max-w-3xl transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700"
          >
            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-2xl">
              <div className="flex-1">
                {/* Header */}
                <SlideOverDialogHeader title={title} onClose={onClose} />

                {/* Divider container */}
                {children}
              </div>

              {/* Action buttons */}
              {/*<div className="shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">*/}
              {/*  <div className="flex justify-end space-x-3">*/}
              {/*    <button*/}
              {/*      type="button"*/}
              {/*      className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"*/}
              {/*      onClick={onClose}*/}
              {/*    >*/}
              {/*      Cancel*/}
              {/*    </button>*/}
              {/*    <button*/}
              {/*      type="submit"*/}
              {/*      className="inline-flex justify-center rounded-md border border-transparent bg-primary py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"*/}
              {/*    >*/}
              {/*      Create*/}
              {/*    </button>*/}
              {/*  </div>*/}
              {/*</div>*/}
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>
)
